import(/* webpackMode: "eager" */ "/codebuild/output/src2048061829/src/app/(auth)/login/page.js");
